import z from 'zod';

export type AccessoryCategoryMappingDto = {
	id: string;
	name: string;
};

export const AccessoryCategoryMappingDtoSchema: z.ZodType<AccessoryCategoryMappingDto> = z.object({
	id: z.string(),
	name: z.string(),
});
